import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class CategoriaDocumentoService implements BaseServiceCadastros<CategoriaDocumento> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/categoriaDocumento/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<CategoriaDocumento>((resolve, reject): void => {
            api
                .get(`/categoriaDocumento/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(categoriaDocumento: CategoriaDocumento) {
        return new Promise<CategoriaDocumento>((resolve, reject): void => {
            let url = `/categoriaDocumento/incluir`;
            api
                .post(url, JSON.stringify(categoriaDocumento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(categoriaDocumento: CategoriaDocumento) {
        return new Promise<CategoriaDocumento>((resolve, reject): void => {
            api
                .put(`/categoriaDocumento/editar`, JSON.stringify(categoriaDocumento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/categoriaDocumento/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/categoriaDocumento/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default CategoriaDocumentoService;